if (!customElements.get('mac-collection-landing')) {
  customElements.define('mac-collection-landing', class extends HTMLElement {
    connectedCallback() {
      if (this.onCategoryClick) return;
      const filters = this.querySelector('.mac-landing__filters');
      const models = this.querySelector('.mac-landing__models');
      if (!filters || !models) return;
      this.onCategoryClick = (event) => {
        const button = event.target.closest('[data-mac-category]');
        if (!button || !filters.contains(button)) return;
        if (button.getAttribute('aria-pressed') === 'true') return;
        const category = button.dataset.macCategory;
        filters.querySelectorAll('button').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });
        this.changeCategory(models, category);
      };
      filters.addEventListener('click', this.onCategoryClick);
      filters.hidden = false;
      this.initDock();
    }
    initDock() {
      const nav = this.querySelector('.mac-landing__families');
      if (!nav) return;
      const links = [...nav.querySelectorAll('.mac-landing__family-link')];
      const motion = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
      this.dockEvents = new AbortController();
      const options = { signal: this.dockEvents.signal, passive: true };
      const reset = () => {
        cancelAnimationFrame(this.dockFrame);
        this.dockFrame = null;
        links.forEach((link) => {
          link.style.removeProperty('--dock-scale');
          link.style.removeProperty('--dock-lift');
        });
      };
      const move = (event) => {
        if (!motion.matches || event.pointerType === 'touch') return;
        this.dockX = event.clientX;
        if (this.dockFrame != null) return;
        this.dockFrame = requestAnimationFrame(() => {
          this.dockFrame = null;
          // Measure fixed link boxes, not the images being scaled, to avoid feedback jitter.
          const weights = links.map((link) => {
            const box = link.getBoundingClientRect();
            const distance = Math.abs(this.dockX - box.left - box.width / 2);
            const radius = box.width * 1.8;
            return distance < radius ? (Math.cos(Math.PI * distance / radius) + 1) / 2 : 0;
          });
          links.forEach((link, index) => {
            link.style.setProperty('--dock-scale', String(1 + weights[index] * 0.45));
            link.style.setProperty('--dock-lift', `${weights[index] * -5}px`);
          });
        });
      };
      nav.addEventListener('pointermove', move, options);
      nav.addEventListener('pointerleave', reset, options);
      nav.addEventListener('pointercancel', reset, options);
      nav.addEventListener('scroll', reset, options);
      motion.addEventListener('change', reset, options);
      this.resetDock = reset;
    }
    async changeCategory(models, category) {
      const revision = this.revision = (this.revision || 0) + 1;
      const height = models.getBoundingClientRect().height;
      const { opacity, transform } = getComputedStyle(models);
      this.transition?.cancel();
      const update = () => {
        models.querySelectorAll('[data-mac-model]').forEach((model) => {
          model.hidden = category !== 'all' && model.dataset.macModel !== category;
        });
        models.scrollLeft = 0;
      };
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !models.animate) {
        update();
        return;
      }
      this.transition = models.animate([
        { opacity, transform, height: `${height}px` },
        { opacity: 0, transform: 'translateY(-4px)', height: `${height}px` }
      ], { duration: 120, easing: 'ease-out', fill: 'forwards' });
      try { await this.transition.finished; } catch { return; }
      if (revision !== this.revision || !this.isConnected) return;
      update();
      this.transition.cancel();
      const nextHeight = models.getBoundingClientRect().height;
      this.transition = models.animate([
        { opacity: 0, transform: 'translateY(8px)', height: `${height}px` },
        { opacity: 1, transform: 'translateY(0)', height: `${nextHeight}px` }
      ], { duration: 320, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
      try { await this.transition.finished; } catch { return; }
      if (revision === this.revision) this.transition = null;
    }
    disconnectedCallback() {
      this.resetDock?.();
      this.dockEvents?.abort();
      this.revision = (this.revision || 0) + 1;
      this.transition?.cancel();
      this.querySelector('.mac-landing__filters')?.removeEventListener('click', this.onCategoryClick);
      this.onCategoryClick = null;
    }
  });
}
